import { isHTMLElement, isSVGElement } from '../../../utilities/dom.mjs';
import { isScrollable } from '../../../utilities/scroll.mjs';

function findFirstScrollableChild(node) {
  if (!isHTMLElement(node) || isSVGElement(node)) {
    return null;
  }
  if (isScrollable(node)) {
    return node;
  }
  for (const childNode of node.children) {
    if (isHTMLElement(childNode)) {
      const scrollableChild = findFirstScrollableChild(childNode);
      if (scrollableChild) {
        return scrollableChild;
      }
    }
  }
  return null;
}

export { findFirstScrollableChild };
